<template>
  <v-sheet color="grey lighten-4" class="py-8 py-sm-10 py-md-12 py-lg-14">
    <v-container>
      <v-row align="center" justify="center">
        <v-col
          cols="12"
          md="5"
          lg="4"
          class="d-flex justify-space-around px-lg-8"
        >
          <Title :center="sm" class="mb-md-n4">
            Trabalhamos com as
            <span class="secondary--text">melhores marcas</span>
          </Title>
        </v-col>
        <v-col cols="12" sm="10" md="7" lg="6">
          <v-row class="ma-sm-n1 ma-sm-n3 ma-lg-n5">
            <v-col
              cols="4"
              v-for="({ img, title, link }, keyItem) in items"
              :key="keyItem"
              class="pa-1 pa-sm-3 pa-lg-5 item"
            >
              <a v-ripple v-if="link && img" :href="link" target="_blank">
                <img
                  :src="files + img"
                  class="d-block pa-5 item-img"
                  :alt="title"
                />
              </a>

              <img
                v-else-if="img"
                :src="files + img"
                class="d-block pa-5 item-img"
                alt="img"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import Title from "../../widgets/Title.vue";

const _config = {
  mod: "brands",
};

export default {
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    Title,
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 1 / 1;
    background-color: #ffffff;
    object-fit: contain;
    -o-object-fit: contain;
    width: 100%;
  }
}
</style>
